import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Miner = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M11.727 4.891h.814a.458.458 0 1 0 0-.916h-.814v.916Zm0 1.552h.814a.458.458 0 1 0 0-.915h-.814v.915Zm-.3.983a.3.3 0 0 1-.3-.3V5.49h-.214a.3.3 0 0 1 0-.6h.214V3.255a.3.3 0 1 1 .6 0v.121h.256V3.34a.3.3 0 1 1 .6 0v.037a1.063 1.063 0 0 1 1.027 1.056 1.049 1.049 0 0 1-.345.777 1.048 1.048 0 0 1 .043 1.511 1.064 1.064 0 0 1-.726.322.3.3 0 1 1-.6 0h-.257v.084a.3.3 0 0 1-.3.3h.002Zm.685-5.516a3.293 3.293 0 1 0 0 6.586 3.293 3.293 0 0 0 0-6.586Zm0 7.184a3.892 3.892 0 1 1 3.891-3.893 3.896 3.896 0 0 1-3.891 3.892v.001ZM.712 4.038l.15.26a1.497 1.497 0 1 0 2.592-1.497l-.15-.26L.713 4.038Zm2.256 6.303 1.66 2.875c.488.845 1.484 1.186 2.22.76l1.995-1.15a1.439 1.439 0 0 0 .682-.978 1.89 1.89 0 0 0-.23-1.326l-1.66-2.875L5.56 8.843l.45.777a.3.3 0 1 1-.52.3l-.448-.777-2.074 1.198Zm3.19 4.417a2.411 2.411 0 0 1-2.049-1.242L2.3 10.383a.3.3 0 0 1 .11-.41l2.333-1.347-1.805-3.131a2.097 2.097 0 0 1-2.593-.9l-.3-.519a.3.3 0 0 1 .11-.409l3.11-1.796a.3.3 0 0 1 .41.11l.3.518a2.097 2.097 0 0 1-.519 2.695l1.807 3.129 2.333-1.347a.3.3 0 0 1 .408.111l1.81 3.133a2.49 2.49 0 0 1 .298 1.747 2.03 2.03 0 0 1-.969 1.375l-1.994 1.152a1.97 1.97 0 0 1-.99.262v.002Z" />
    </svg>
  );
};

Miner.category = 'product-category';

Miner.displayName = 'Miner';
